import { F as FeatureFlag } from './featureFlagController-fa69abe2.js';
import { V as VegaLoader, a as VegaNotify, b as VegaThemeManager } from './themeManager-c1bb222d.js';
import { s as setVegaLogLevel } from './log-a824be80.js';
import { V as VegaDialog } from './vegaDialogController-a23aae0f.js';

/**
 * Default export function that will be used by stencil global script,
 * which will be invoked before library loaded.
 */
function appGlobalScript () {
  disableFeatureFlagFromClientGlobal();
  enableFeatureFlagFromClientGlobal();
  injectVegaLoaderIntoGlobal();
  injectVegaNotifyIntoGlobal();
  injectVegaThemeManagerIntoGlobal();
  injectVegaLogLevelIntoGlobal();
  injectVegaDialogIntoGlobal();
}
/**
 * Disable feature flags from the client global defined lists.
 */
function disableFeatureFlagFromClientGlobal() {
  if (globalThis['VegaDisabledFeatureKeys']) {
    FeatureFlag.disable(...globalThis['VegaDisabledFeatureKeys']);
  }
}
/**
 * This function enables feature flags based on a global variable in TypeScript.
 */
function enableFeatureFlagFromClientGlobal() {
  if (globalThis['VegaEnabledFeatureKeys']) {
    FeatureFlag.enable(...globalThis['VegaEnabledFeatureKeys']);
  }
}
/**
 * Inject VegaLoader to global as a public api
 */
function injectVegaLoaderIntoGlobal() {
  globalThis['VegaLoader'] = VegaLoader;
}
/**
 * Inject VegaNotify to global as a public api
 */
function injectVegaNotifyIntoGlobal() {
  globalThis.VegaNotify = VegaNotify;
}
/**
 * Inject VegaThemeManager to global as a public api
 */
function injectVegaThemeManagerIntoGlobal() {
  globalThis.VegaThemeManager = VegaThemeManager;
}
/**
 * Inject VegaLogLevel to global as a public api
 */
function injectVegaLogLevelIntoGlobal() {
  globalThis.setVegaLogLevel = setVegaLogLevel;
}
/**
 * Inject VegaDialog to global as a public api
 */
function injectVegaDialogIntoGlobal() {
  globalThis.VegaDialog = VegaDialog;
}

const globalScripts = appGlobalScript;

export { globalScripts as g };
